module.exports = __webpack_public_path__ + "img/rnd-logo.75710c9f.png";